import { Box, Container, createStyles, makeStyles, Theme, useMediaQuery, useTheme } from "@material-ui/core";
import createBreakpoints from "@material-ui/core/styles/createBreakpoints";
import { setHours, setMinutes, setSeconds } from "date-fns";
import { useEffect } from "react";
import { colors } from "swyft-react-core";
import { useQuoteAvailableDeductions } from "../../../api/Deduction/DeductionApi";
import { Quote } from "../../../api/Quote/Quote";
import CountdownTimer from "../../../components/CountDownTimer";
import OverrideTheme from "../../../components/OverrideTheme";
import { TF } from "../../../components/typography/TF";

export const QuoteAvailableDeduction = ({ quote }: Props) => {
  const quoteId = quote.id;
  const theme = useTheme();

  const isSmall = useMediaQuery(theme.breakpoints.down("sm"));

  const classes = useStyles({
    top: 0
  });

  let { data, refetch } = useQuoteAvailableDeductions(quoteId);

  useEffect(() => {
    if (quoteId) {
      refetch();
    }
  }, [quoteId, refetch]);

  let deduction = data && data.length ? data[0] : null;
  if (!deduction) {
    return <></>;
  } else if (deduction.expireInDays) {
    let expiryDate = new Date(quote.sent ? quote.sent : 0);
    expiryDate.setDate(expiryDate.getDate() + deduction.expireInDays);
    deduction.expiryDate = expiryDate.toString()
  }

  const deductionView = deduction && (
    <>
      <Box display="flex" flexDirection={isSmall ? "column" : "row"} justifyContent="center">
        <Box mt={isSmall ? 1 : 0} mr={isSmall ? 0 : 6}>
          <TF variant="body1" component="span">
            SALE ENDS IN &nbsp;
          </TF>
          <TF variant="h6" bold component="span">
            {deduction.expiryDate && (
              <CountdownTimer
                className={classes.coundown}
                date={setSeconds(setMinutes(setHours(new Date(deduction.expiryDate), 23), 59), 59)}
              />
            )}
          </TF>
        </Box>
        <Box mt={isSmall ? 2 : 0}>
          <TF variant="h6" bold>
            {deduction.timedOfferText}&nbsp;
            <TF variant="h6" component="span" bold color="secondary">
              {deduction.promoCode}
            </TF>
          </TF>
        </Box>
      </Box>
    </>
  );
  return (
    <OverrideTheme>
      <Box className={classes.bannerOuter} p={1}>
        <Container maxWidth="lg" className={classes.bannerInner}>
          {deductionView}
        </Container>
      </Box>
    </OverrideTheme>
  );
};

interface StyleProp {
  top: number;
}

const breakpoints = createBreakpoints({});

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    coundown: {
      color: colors.primary,
      padding: theme.spacing(0.5),
      backgroundColor: colors.white,
      marginRight: theme.spacing(0.5),
      marginLeft: theme.spacing(0.5)
    },
    bannerOuter: (props: StyleProp) => ({
      backgroundColor: colors.primary,
      color: colors.white,
      marginTop: theme.spacing(props.top)
    }),
    bannerInner: {
      textAlign: "center",
      height: "30px",
      [breakpoints.down("sm")]: {
        height: "auto",
        minHeight: "83px"
      }
    }
  })
);

interface Props {
  quote: Quote;
}
